import { render, staticRenderFns } from "./ContentLayoutInner.vue?vue&type=template&id=324579bc"
import script from "./ContentLayoutInner.vue?vue&type=script&lang=ts"
export * from "./ContentLayoutInner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports